<template>
  <ul class="g-layout-user-menu">
    <li @click="changeLanguage('zh-CN')">
      简体中文
    </li>
    <li @click="changeLanguage('en-US')">
      English
    </li>
  </ul>
</template>
<script>
import { setCookie } from '@/libs/cookie';

export default {
  data() {
    return {
      currentLanguage: 'en-US',
    };
  },

  methods: {
    // 切换语言
    changeLanguage(val) {
      // 记录用于提交
      this.currentLanguage = val;

      // 设置cookie，用于刷新时，保持当前语言
      setCookie('locale', val);

      // 改变静态语言
      this.$i18n.locale = val;

      // 改变UI组件的语言
      this.$store.commit('setUiCurrentLocale', val);

      // 重新reload页面->改变页面title的语言
      window.location.reload();
    },
  },
};
</script>
<style lang="less" scoped>
.g-layout-user-menu {
  margin: 0;
  padding: 10px 0;

  li {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 36px;
    line-height: 36px;
    margin: 0;
    width: 100%;
    cursor: pointer;
    padding: 12px 16px;
    white-space: nowrap;

    &:hover {
      color: @primary-color;
      background: rgba(0, 0, 0, 0.04);
    }
  }
}
</style>
